import React, { useState, useEffect } from "react";
import { isPlatform } from "@ionic/react";
import { IonGrid, IonRow, IonCol, IonImg } from '@ionic/react';


import {
  Camera,
  CameraResultType,
  CameraSource,
  Photo,
} from "@capacitor/camera";
import { Filesystem, Directory } from "@capacitor/filesystem";
import { Preferences } from "@capacitor/preferences";
import { Capacitor } from "@capacitor/core";


export function TakePhoto(props) {

  let [photos, setPhotos] = useState([]);
    
   useEffect(() => {


        Camera.getPhoto({
          resultType: CameraResultType.Base64,
          source: CameraSource.Camera,
          quality: 100,
          format: 'jpeg'

        }).then(res => {

            const fileName = new Date().getTime() + ".jpeg";

            const blob = b64toBlob(res.base64String, '');
          

            const blobUrl = URL.createObjectURL(blob);

            setPhotos((prevSetPhotos) => {
              return prevSetPhotos.concat({
                 filepath: fileName,
                 webviewPath: blobUrl,
              })
            });

            let tempObjectFile = new File([blob], blobUrl, {
              enctype: 'multipart/form-data',
              type: 'image/jpeg',
              name: 'xImageFile',
              accept: "image/*",
            })


           /* isJPEG(blob).then(result => {
                 alert("Is JPEG:", result); // Should print true

           }).catch(error => {
             alert("Error checking JPEG:", error);
           });*/
                //props.onSelectedFile(Object.entries(res));
          props.onSelectedFile(tempObjectFile);

        });

    //};

   }, []) 

   function isJPEG(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        
        reader.onloadend = function() {
            const arr = new Uint8Array(reader.result).subarray(0, 4);
            let header = "";
            for (let i = 0; i < arr.length; i++) {
                header += arr[i].toString(16);
            }
          
        };

        reader.onerror = function() {
            reject(new Error("Error reading blob"));
        };

        reader.readAsArrayBuffer(blob.slice(0, 4));

    });
}

   function b64toBlob(base64String, contentType, sliceSize=512) {

    const byteCharacters = atob(base64String);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
  
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
  
    const blob = new Blob(byteArrays, {type: contentType});

    return blob;
  }
  
    return (

      <IonGrid>
        <IonRow>
          {photos.map((photo, index) => (
            <IonCol size="6" key={index}>
              <IonImg src={photo.webviewPath} />
            </IonCol>
          ))}
        </IonRow>
      </IonGrid>
    );
  
  }

  /*export interface UserPhoto {
    filepath: string;
    webviewPath?: string;
  }*/